// SEE: https://github.com/getslick/api.core/blob/staging/docs/pos.md
// SEE: https://stripe.com/docs/api/terminal/readers/list#list_terminal_reader-status

// SEE: https://getslick.atlassian.net/browse/GS-10931
// SEE: https://getslick.atlassian.net/browse/GS-11050
// SEE: https://getslick.slack.com/archives/C017UAPSFJM/p1675679927580149?thread_ts=1675670472.905119&cid=C017UAPSFJM
// reader_status can be: "no_reader", "ordered", "online", "offline", "inactive"

const POS_READER_STATUS = Object.freeze({
  online: 'online',
  offline: 'offline', // Stripe is not able to reach the reader
  noReader: 'no_reader',
  ordered: 'ordered',
  inactive: 'inactive', //  The salon has a reader with us, but they cannot take pos_payment
  tapToPayTerminalNoStatus: 'tap_to_pay_terminal_no_status', // hidden — never shown in UI
  unavailable: 'Reader Status unavailable', // mapped to offline
});

// noinspection JSUnusedGlobalSymbols
export default POS_READER_STATUS;
